module.exports = __webpack_public_path__ + "media/images/pulse-df50badc2377e183313637b492c50604.svg";